// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const SettingsFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m10.135 21-.362-2.892a5.306 5.306 0 0 1-1.035-.454 5.082 5.082 0 0 1-.947-.663l-2.668 1.134-1.865-3.25 2.306-1.739a9.064 9.064 0 0 1-.073-.558 5.11 5.11 0 0 1 0-1.088c.019-.186.043-.395.073-.627L3.258 9.126l1.865-3.212L7.771 7.03c.299-.249.622-.473.97-.673a5.54 5.54 0 0 1 1.013-.464L10.134 3h3.732l.361 2.912c.383.134.722.289 1.016.463.294.174.597.392.91.654l2.724-1.115 1.865 3.211-2.382 1.796a2.6 2.6 0 0 1 .092.569c.006.172.01.342.01.51a5.769 5.769 0 0 1-.108 1.117l2.344 1.758-1.865 3.25-2.68-1.154a7.139 7.139 0 0 1-.941.673 4.774 4.774 0 0 1-.985.445L13.866 21h-3.731ZM11 20h1.956l.37-2.708a5.55 5.55 0 0 0 1.36-.549 6.367 6.367 0 0 0 1.231-.956l2.495 1.063.994-1.7-2.189-1.644c.084-.285.139-.547.166-.786a6.464 6.464 0 0 0 0-1.44 4.323 4.323 0 0 0-.166-.747l2.227-1.683-.994-1.7-2.552 1.07c-.302-.333-.7-.644-1.193-.935-.493-.29-.96-.482-1.4-.577L13 4h-1.994l-.312 2.689a4.866 4.866 0 0 0-1.39.52 5.951 5.951 0 0 0-1.26.985L5.55 7.15l-.994 1.7 2.17 1.62a3.277 3.277 0 0 0-.176.73 6.51 6.51 0 0 0-.05.82c0 .253.017.505.05.755s.085.494.156.73l-2.15 1.645.994 1.7 2.475-1.05c.392.396.8.714 1.222.953.423.239.899.425 1.428.558L11 20Zm.973-5.5c.698 0 1.289-.242 1.773-.727A2.412 2.412 0 0 0 14.473 12c0-.697-.242-1.289-.727-1.773a2.413 2.413 0 0 0-1.773-.727c-.701 0-1.293.242-1.776.727A2.417 2.417 0 0 0 9.473 12c0 .697.241 1.289.724 1.773.483.485 1.075.727 1.776.727Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const SettingsFillOffset: IconOffset = {
    vertical: 12, // Store Custom Code
    horizontal: 14, // Store Custom Code
};

export default React.memo(SettingsFill);
